import React, { useState } from 'react'
import logo from '../Assets/ti_logo.jpg'

import { useNavigate, useSearchParams } from 'react-router'
import {
  ax_auth_forgotPass,
  ax_auth_login,
  ax_auth_resetPass
} from '../api/auth'
import toast from 'react-hot-toast'

function Login () {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const [userIDValue, setUserIDValue] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const [isFocusedUserID, setIsFocusedUserID] = useState(false)
  const [isFocusedPassword, setIsFocusedPassword] = useState(false)

  const [isForgotpass, setIsForgotpass] = useState(false)

  const navigate = useNavigate()

  // useEffect(() => {
  //   const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  //   if (token) {
  //     navigate('/'); // Redirect if already logged in
  //   }
  // }, [navigate]);

  const [errors, setErrors] = useState({
    userID: '',
    password: ''
  })

  const handleValidation = () => {
    let formErrors = { userID: '', password: '' }
    let isValid = true

    if (!token) {
      if (!userIDValue.trim()) {
        formErrors.userID = 'User ID is required.'
        isValid = false
      }
    }

    if (isFocusedPassword) {
      if (!passwordValue.trim()) {
        formErrors.password = 'Password is required.'
        isValid = false
      }
    }

    setErrors(formErrors)
    return isValid
  }

  const onForgotPassClick = async () => {
    setIsForgotpass(true)
    setPasswordValue('')
    setIsFocusedPassword(false)
    navigate('/auth')
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!handleValidation()) {
      toast.error('Please fill the required fields!')
      return // Stop execution if validation fails
    }

    // if (userIDValue.trim().length === 0 && passwordValue.trim().length === 0) {
    //   toast.error("Provide valid credentials!");
    // } else {
    try {
      if (isForgotpass && !token) {
        const axForgotpass = await ax_auth_forgotPass({ userId: userIDValue })

        console.log('axForgotpass - ', axForgotpass)

        if (axForgotpass && axForgotpass.success) {
          toast.success(axForgotpass?.description)
          setUserIDValue('')
          setIsFocusedUserID(false)
        } else {
          toast.error(axForgotpass?.response?.data?.description)
        }
      } else if (!isForgotpass && token) {
        const axResetPass = await ax_auth_resetPass({
          token,
          newPassword: passwordValue
        })

        console.log('axResetPass - ', axResetPass)

        if (axResetPass && axResetPass.success) {
          toast.success(axResetPass?.description)
          navigate('/auth')
          setPasswordValue('')
          setIsFocusedPassword(false)
          setIsForgotpass(false)
        } else {
          toast.error(axResetPass?.response?.data?.description)
        }
      } else {
        const data = {
          userId: userIDValue,
          passwordValue,
          isChecked
        }

        //   {
        // } else {
        // console.log("Form validation failed!");
        // }
        console.log('data', data)

        const axLogin = await ax_auth_login(data)

        console.log('axLogin', axLogin)
        if (axLogin && axLogin.success) {
          navigate('/')
          sessionStorage.setItem('userToken', axLogin?.token)
          toast.success(axLogin?.description)
        } else {
          toast.error(axLogin?.response?.data?.message)
        }
      }
    } catch (e) {
      console.error('Error while logging in: ', e)
    }
    // }
  }

  return (
    <section className='h-full flex p-6 lg:p-0 items-center justify-center bg-white m-auto'>
      {/* {JSON.stringify(token)} */}
      <div className='p-7 shadow-xl bg-white rounded-xl w-full max-w-md'>
        <div className='flex justify-center mb-6'>
          <img src={logo} alt='login logo' className='w-24' />
        </div>

        <div className='text-center'>
          <h2 className='text-2xl font-bold'>Hello! Let's get started</h2>
          <p className='text-gray-600 mt-2'>
            {!token && !isForgotpass
              ? 'Sign in to continue'
              : !token && isForgotpass
              ? 'Forgot Password'
              : 'Rest Password'}
          </p>
        </div>

        <form className='mt-6 space-y-6'>
          <div className='relative mb-4'>
            {!token ? (
              <>
                <input
                  type='text'
                  id='userid'
                  className='w-full p-3 border rounded-md outline-none focus:ring-2 focus:ring-blue-400'
                  value={userIDValue}
                  onFocus={() => setIsFocusedUserID(true)}
                  onBlur={() => setIsFocusedUserID(userIDValue.trim() !== '')}
                  onChange={e => setUserIDValue(e.target.value)}
                />
                <label
                  htmlFor='userid'
                  className={`absolute left-3 transition-all duration-300 transform ${
                    isFocusedUserID || userIDValue
                      ? 'scale-75 -top-3 left-3 text-blue-500'
                      : 'top-3 text-gray-500'
                  }`}
                  style={{
                    backgroundColor: 'white',
                    padding: '0 4px',
                    zIndex: 1
                  }}
                >
                  User ID
                </label>
                {errors.userID && (
                  <p className='text-sm text-red-500 mt-1'>{errors.userID}</p>
                )}{' '}
              </>
            ) : null}
          </div>
          {isForgotpass ? null : (
            <div className='relative mb-4'>
              <input
                type='password'
                id='password'
                className='w-full p-3 border rounded-md outline-none  focus:ring-2 focus:ring-blue-400'
                value={passwordValue}
                onFocus={() => setIsFocusedPassword(true)}
                onBlur={() => setIsFocusedPassword(passwordValue.trim() !== '')}
                onChange={e => setPasswordValue(e.target.value)}
              />
              <label
                htmlFor='password'
                className={`absolute left-3 transition-all duration-300 transform ${
                  isFocusedPassword || passwordValue
                    ? 'scale-75 -top-3 left-3 text-blue-500'
                    : 'top-3 text-gray-500'
                }`}
                style={{
                  backgroundColor: 'white',
                  padding: '0 4px',
                  zIndex: 1
                }}
              >
                {!token ? 'Password' : 'New Password'}
              </label>
              {errors.password && (
                <p className='text-sm text-red-500 mt-1'>{errors.password}</p>
              )}
            </div>
          )}

          <div className='flex items-center justify-end mb-4'>
            {isForgotpass || token ? null : (
              <div className='flex-grow'>
                <input
                  type='checkbox'
                  id='keepSignedIn'
                  className='mr-2'
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
                <label htmlFor='keepSignedIn' className='text-gray-600 mr-2'>
                  Keep me signed in
                </label>
              </div>
            )}
            <span
              className='text-blue-500 hover:underline text-sm font-semibold cursor-pointer'
              onClick={
                isForgotpass ? () => setIsForgotpass(false) : onForgotPassClick
              }
            >
              {(token && !isForgotpass) || isForgotpass
                ? 'Back to login'
                : 'Forgot Password?'}
            </span>
          </div>

          <div className='text-center'>
            <button
              type='submit'
              onClick={handleSubmit}
              className='w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500'
            >
              {!isForgotpass && token
                ? 'Reset Password'
                : isForgotpass && !token
                ? 'Forgot Password'
                : 'SIGN IN'}
            </button>
          </div>

          <div className='text-center mt-4'>
            <p className='text-sm'>
              Don't have an account?{' '}
              <span className='font-semibold'>Contact admin.</span>
            </p>
          </div>
        </form>
      </div>
    </section>
  )
}

export default Login
